export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-w@3x.4d6ddb91.webp";